<template>
  <div class="prontuario-medico-details">
    <page-header :title="title" />
    <page-section :group-label="$t('Prontuario')">
      <v-row no-gutters>
        <v-col class="mb-4" cols="12">
          <field-section
            :value="pessoa.prontuarioMedico"
            :is-restrict="
              $store.getters['pessoa/isRestrict']('prontuarioMedico')
            "
          >
            <template #value>
              <div v-if="pessoa.prontuarioMedico" class="mt-2 d-inline">
                <v-btn
                  link
                  tag="a"
                  target="_blank"
                  :href="
                    $store.state.medicalDocumentsURL + pessoa.prontuarioMedico
                  "
                  elevation="0"
                  small
                  color="blue lighten-1"
                  text
                >
                  <v-icon size="18" class="mr-1">mdi-open-in-new</v-icon>
                  {{ $t("visualizar") }}
                </v-btn>
              </div>
              <div v-else>
                <i class="text-caption grey--text text--darken-1">
                  {{ $t("nenhum_anexo") }}
                </i>
              </div>
            </template>
          </field-section>
        </v-col>
        <v-col v-if="$i18n.i18next.language === 'pt_br'" class="mb-4" cols="12">
          <field-section
            label="Número do SUS"
            :value="pessoa.numeroSus"
            :is-restrict="$store.getters['pessoa/isRestrict']('numeroSus')"
          />
        </v-col>
      </v-row>
    </page-section>
    <page-section :group-label="$t('Medico_Particular')">
      <v-row no-gutters>
        <v-col class="mb-4" cols="12" md="4">
          <field-section
            :label="$t('Nome_Medico')"
            :value="pessoa.nomeMedico | toPT_BRCapitalize"
            :is-restrict="$store.getters['pessoa/isRestrict']('nomeMedico')"
          />
        </v-col>
        <v-col class="mb-4" cols="12" md="4">
          <field-section
            :label="$t('Telefone_Medico')"
            :value="pessoa.foneMedico"
            :is-restrict="$store.getters['pessoa/isRestrict']('foneMedico')"
          />
        </v-col>
        <v-col class="mb-4" cols="12" md="4">
          <field-section
            :label="$t('Empresa_Comp_Div')"
            :value="pessoa.empresaMedico | toPT_BRCapitalize"
            :is-restrict="$store.getters['pessoa/isRestrict']('empresaMedico')"
          />
        </v-col>
        <v-col class="mb-4" cols="12">
          <field-section
            :label="$t('Observacao')"
            :value="pessoa.observacao | capitalize({ onlyFirstLetter: true })"
            :is-restrict="$store.getters['pessoa/isRestrict']('observacao')"
          />
        </v-col>
      </v-row>
    </page-section>
    <page-section :group-label="$t('Enfermagem')">
      <v-row no-gutters>
        <v-col class="mb-4" cols="12" md="4">
          <field-section
            :label="$t('Nome_Profissional')"
            :value="pessoa.nomeEnfermeiro | toPT_BRCapitalize"
            :is-restrict="$store.getters['pessoa/isRestrict']('nomeEnfermeiro')"
          />
        </v-col>
      </v-row>
    </page-section>
    <Form :title="title" :data="pessoa" />
  </div>
</template>

<script>
import i18next from "i18next";
import PageHeader from "@/components/headers/page-header";
import PageSection from "@/components/sections/page-section";
import FieldSection from "@/components/sections/field-section";
import Form from "./form";
export default {
  metaInfo: {
    titleTemplate: (i18next.t("Prontuario_Medico") || "") + " | %s",
  },
  components: { FieldSection, PageSection, PageHeader, Form },
  data: () => ({
    title: i18next.t("Prontuario_Medico"),
  }),
  computed: {
    pessoa() {
      return this.$store.state.pessoa.data || {};
    },
  },
};
</script>

<style scoped></style>
